import { useState, lazy, Suspense } from "react";
import axios from 'axios';
import Button from '@/components/Button';
import { 
   CloudDownload as SyncIcon
} from '@mui/icons-material';

import { getErrorMessage } from '@/utils/Errors';

const Backdrop = lazy(() => import('@mui/material/Backdrop'));
const CircularProgress = lazy(() => import('@mui/material/CircularProgress'));

export default function ResourcesGroupsButtons({t,user,language,apiUrl,token,handleLogin,sendMessage}){

    const [ backdrop, setBackdrop ] = useState(false);

    const handleButtonSync = () => {

        setBackdrop(true);

        var apiPath = '/external/resources/groups/sync';

        const config = {
            headers: { Authorization: `Bearer ${token}` } 
        };

        const send = {
            language: language,
            companyuser: user?.company
        };

        var errorMessage = t('actions.sync.error');            

        axios.post(apiUrl+apiPath,send,config)
        .then(function (response) {
            
            if(response?.data){
          
                var responseData = response.data;

                // if result is ok (1)                
                if(responseData?.result){                                  
                    sendMessage(t('actions.sync.success'));                    
                    setTimeout(() => {
                        window.location.reload();
                    },1000);
                } 
                else{

                    if(responseData?.status && responseData.status === 401){
                        handleLogin();
                    }
                    else{                       
                        // check error message
                        if(responseData?.data?.reasons){                            
                            const reasons = responseData?.data?.reasons;
                            errorMessage = getErrorMessage(t,'tickets',reasons);
                        }
                        
                        setBackdrop(false);
                        sendMessage(errorMessage,'error');
                    }
                }
            }
            else{
                setBackdrop(false);
                sendMessage(errorMessage,'error');   
            }
        })
        .catch(function (error){
            
            if(error?.status && error.status === 401){
                handleLogin();
            }
            else{         
                setBackdrop(false);           
                sendMessage(errorMessage,'error');
            }
        });
    }

    return (
        <>
        {
            backdrop &&
            <Suspense>
                <Backdrop
                    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                    open={backdrop}
                    //sx={sxBackdrop}
                    //onClick={handleClose}
                  >
                    <div className='text-center'>
                        <CircularProgress color="inherit"/>                        
                        <div>{t('actions.sync.loading')}</div>
                    </div>
                </Backdrop>
            </Suspense>
        }
        <div className='flex justify-center items-center w-full max-md:grid max-md:grid-cols-12 my-4'>
            <div className={'mx-1 max-md:my-1 max-md:col-span-12 max-md:text-center'}>
                <Button            
                    onClick={handleButtonSync}
                    type="edit"
                    icon={<SyncIcon/>}
                />
            </div>
        </div>
        </>
    );
}